import * as React from "react";
import { toINR } from "../../../../service/numberFormat";
import SlideUpPopup from "../../../../generic/slideUpPopup";
import HoldMfUnusablePopup from "./holdMfUnusablePopup";

export interface IHoldMfUnusableRowMobProps {
	rowData: any;
}

const HoldMfUnusableRowMob: React.FC<IHoldMfUnusableRowMobProps> = props => {
	const [isPopupOpen, setIsPopupOpen] = React.useState(false);

	return (
		<>
			<li className="data_row" onClick={() => setIsPopupOpen(true)}>
				<div className="row1">
					<div className="col trdSym">
						<span dangerouslySetInnerHTML={{ __html: props.rowData.companyName }}></span>
					</div>
					<div className="col ltp">₹{toINR(props.rowData.holdingValue)}</div>
				</div>
				<div className="row2">
					<div className="col totQty">Pledged Qty: {toINR(props.rowData.pledgQty)}</div>
					<div className="col totQty">Locked-in Qty: {toINR(props.rowData.lockedInQty)}</div>
				</div>
			</li>

			{isPopupOpen && (
				<SlideUpPopup closePopup={() => setIsPopupOpen(false)}>
					<HoldMfUnusablePopup data={props.rowData} onClose={() => setIsPopupOpen(false)} />
				</SlideUpPopup>
			)}
		</>
	);
};

export default HoldMfUnusableRowMob;
